import React from 'react';

type Portal = 'app' | 'admin' | 'client' | 'superadmin' | 'client-access';

const PORTAL_CONFIG: Record<Portal, { home: string; label: string }> = {
  app:           { home: '/',               label: 'Back to Dashboard' },
  admin:         { home: '/admin/',         label: 'Back to Admin Portal' },
  client:        { home: '/',               label: 'Go to Home Page' },
  superadmin:    { home: '/',               label: 'Back to Console' },
  'client-access': { home: '/client-access/', label: 'Back to Client Access Portal' },
};

interface NotFoundProps {
  portal?: Portal;
}

export default function NotFound({ portal = 'app' }: NotFoundProps) {
  const { home, label } = PORTAL_CONFIG[portal];
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f3f4f8',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter, system-ui, sans-serif',
        gap: 12,
      }}
    >
      <span
        className="material-symbols-outlined"
        style={{ fontSize: 52, color: '#d1d5db' }}
      >
        search_off
      </span>
      <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1e1b4b', margin: 0 }}>
        404 — Page Not Found
      </h1>
      <p style={{ fontSize: 13, color: '#6b7280', margin: 0 }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <a
        href={home}
        style={{
          marginTop: 8,
          padding: '9px 20px',
          background: '#3c228c',
          color: 'white',
          borderRadius: 9,
          fontSize: 13,
          fontWeight: 700,
          textDecoration: 'none',
        }}
      >
        {label}
      </a>
    </div>
  );
}
